// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2nY66","label":"SetPasswdForm_label__1WiJv"};